import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { toastr } from 'react-redux-toastr';
import { Field, reduxForm, FieldArray } from 'redux-form';
import {
    renderSelectField,
    renderEmailInputField,
    renderTextInputField,
    renderPasswordInputField, renderRadioInputField, CheckboxGroup, renderStoryItems
} from '../Layout/FormInputs';
import {
    updateProfilePicLocalStorage, getUserProfilePictureLocalStorage,
    updateUserNameLocalStorage
} from "../../actions/Common";
import { langs } from "../../config/localization";
import {
    getAuthToken
} from "../../actions/Common";
import { Loader } from "../Common/Loader";
import FileInput from "../Common/FileInput";
import ImageCompressor from 'image-compressor.js';
import {eventTracking} from "../../actions/UserAction";
const cities = [
    {
        id: "Los Altos",
        text: "Los Altos"
    },
    {
        id: "Newyork",
        text: "Newyork"
    }
];

import {
  editProfile,
  getProfileDetailsLocalStorage,
  changePassword,
  updateProfilePic,
  getUserProfileDetails
} from "../../actions/UserAction";
import {API_URL, APP_URL, DEFAULT_USER_IMAGE} from "../../config/config";
import {required, maxLength30, maxLength50, maxLength100} from "../../validation";
import {focusOnError} from "../../utils";

let imageURL = '';
class EditProfile extends Component {
    /**
     * Class constructor
     * @param props
     */
    constructor(props) {
        super(props);

        //Keep values in state
        this.state = {
            showLoader: false,
            previewImage: '',
            contentLikeList: {
                action_network_events: 'Action Network Events',
                action_network_initiatives: 'Action Network Initiatives',
                action_network_news: 'Action Network News',
                media_entertainment_for_a_cause: 'Media & Entertainment for a Cause',
                data_research: 'Data & Research',
                innovation_unicorns: 'Innovation & Unicorns',
                learning_content_tool: 'Learning content & tools',
                sustainable_tourism: 'Sustainable Tourism'
            },
            socialNetworkList: {
                 action_networks: 'Action Networks',
                 angel_donors: 'Angel Donors',
                 financing: 'Financing (blockchain, tokens etc.)',
                 gaming_for_good: 'Gaming for Good',
                 nature_and_wilderness: 'Nature and Wilderness',
                 outdoors_and_sports: 'Outdoors and Sports',
            }
        };
    }

    componentWillMount() {
        //Get profile details if user is logged in
        this.profileDetails();
    }

    /**
     * On change profile image
     * @param image
     */
    onChangeProfileImage(image) {
        let fileType = image.type;
        if(fileType.includes('jpg') || fileType.includes('jpeg') || fileType.includes('png')){
            const reader  = new FileReader();

             new ImageCompressor(image, {
                quality: .8,
                width: 150,
                height:150,
                success(result) {

                    reader.readAsDataURL(result);
                    //reader.readAsDataURL(image);
                    reader.onload = function (fileLoadedEvent) {
                            imageURL = fileLoadedEvent.target.result;
                        };
                },
                error(e) {

                },
              });

            let INTERVAL = setInterval(function(){
                if(imageURL != ''){
                    clearInterval(INTERVAL);
                    this.setState({previewImage: imageURL});
                }
            }.bind(this), 100);
        }else{
            this.setState({
                invalidProfilePic : true
            });
        }
    }


    profileDetails() {
      this.props.getUserProfileDetails((response) => {
          if(response != undefined) {
              if (response.status != 200) {
                  if (response.status === 404) {
                    toastr.error(langs.error, langs.messages.resource_not_found);
                  } else {
                    toastr.error(langs.error, langs.messages.default_error);
                  }
              }
          }
      });
    }

    /**
     * Submit edit profile form
     * @param values
     */
    onSubmit(values) {

        this.setState({ showLoader: true });
        if(imageURL!==''){
            values = {...values, profilePic: imageURL};
        }

        /* Action tracking */
        let originRoute = document.referrer;
        let destinationRoute = window.location.href;
        let date = new Date();
        let postData = {type: 'ProfileUpdated', originRoute: originRoute, destinationRoute: destinationRoute, timestamp: date};
        this.props.eventTracking(postData);
        /* Action tracking */

        // Trimming the whiteSpaces
        let trimmedNameWebsite = [];
        let  finalNameWebsite = [];
        if(values.profile && values.profile.yourStories && values.profile.yourStories.nameWebsites.length>0){
            trimmedNameWebsite =  values.profile.yourStories.nameWebsites.map(function(nameWebsite){

                    nameWebsite.Title = (typeof nameWebsite.Title !=='undefined'
                    && nameWebsite.Title !==''
                    && nameWebsite.Title !==null ) ? String.prototype.trim.call(nameWebsite.Title):'';
                    nameWebsite.Website = (typeof nameWebsite.Website !=='undefined'
                    && nameWebsite.Website !==''
                    && nameWebsite.Website !==null) ? String.prototype.trim.call(nameWebsite.Website):'';
                    return nameWebsite;
            });

            trimmedNameWebsite.map(function(nameWebsite){
                if(nameWebsite.Title !=='' || nameWebsite.Website !==''){
                    finalNameWebsite.push(nameWebsite);
                }
            });

        }
        values.name =  String.prototype.trim.call(values.name);
        values.email =  String.prototype.trim.call(values.email);
        if(validate.profile && value.profile.socialNetworks) {
            values.profile.socialNetworks.other =  String.prototype.trim.call(values.profile.socialNetworks.other);
        }
        if(validate.profile && value.profile.yourStories) {
            values.profile.yourStories.nameWebsites = finalNameWebsite;
        }
        //Call the edit profile action
        this.props.editProfile(values, this.props.initialValues.id, (response) => {
            if (response != undefined) {
                this.setState({ showLoader: false });
                if (response.status == 200) {
                    const responseData = response.data;
                    responseData.token = getAuthToken();
                    updateUserNameLocalStorage(responseData.name);
                    updateProfilePicLocalStorage({profilePic : responseData.profilePic});
                    toastr.success(langs.success, langs.messages.profile_update_success);
                    window.location.reload();
                } else if (response.status == 401) {
                    toastr.error(langs.error, langs.messages.unauthenticated_user);
                } else if (response.status == 404) {
                    toastr.error(langs.error, langs.messages.resource_not_found);
                } else {
                    toastr.error(langs.error, langs.messages.default_error);
                }
            }
        });
    }

    socialNetworksLikeHtml() {
        return _.map(this.state.contentLikeList, (value, key) => {
            return (
                <li key={key}>
                    {/* <label>{value}</label> */}
                    <Field
                        name='profile.contentLike.key'
                        type="checkbox"
                        component={renderRadioInputField}
                        label={value}
                    />
                </li>
            );
        });
    }

    /**
     * @name deleteItem
     * @desc Delete Purchanse items
     */
    deleteItem(fields, index){
        const toastrConfirmOptions = {
            onOk: () => {fields.remove(index);},
            onCancel: () => {}
        };
        return toastr.confirm('Are you sure you want to delete this item?', toastrConfirmOptions);
    }

    render(){
        if(this.props.authUserDetails == undefined){
            return <Loader/>
        }

        const {handleSubmit, authUserDetails} = this.props;
        let userProfilePic = authUserDetails.profilePic;
        userProfilePic = (typeof userProfilePic != 'undefined')?(APP_URL + userProfilePic):DEFAULT_USER_IMAGE;

        let previewImage = this.state.previewImage;
        if(previewImage != ''){
            userProfilePic = previewImage;
        }

        if(!this.state.showLoader) {
            return (
                <div className="ed-edit-profile">
                    <form noValidate className="form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <section className="login-form">
                    <div className="row">
                        <div className="medium-12 columns">
                            <div className="breadcumb">
                                <a href="/dashboard" className="breadcumb-underline">My earthDECK </a> > <span className="active breadcumb-underline">Edit Profile</span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-12 columns">
                            <h1 className="page-heading text-center">Edit Profile</h1>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                      <div className="row">
                          <div className="medium-12 columns">
                              <div className="shadow-box clearfix m-b50">
                                  <div className="row">
                                      <div className="medium-12 columns">
                                          <div className="text-center">
                                              <div className="upload-btn-wrapper ed-profile-pic">
                                                  <div className="btn" style={{backgroundImage:`url(${userProfilePic})`, margin: "auto"}}>
                                                      <span className="upload-icon"><img src="/assets/images/eathdeck/edit_profile.png" /></span>
                                                  </div>
                                                  <Field
                                                    name="profilePic"
                                                    component={FileInput}
                                                    onChangeProfileImage={this.onChangeProfileImage.bind(this)}
                                                />
                                                  <label>Display Picture</label>
                                              </div>
                                          </div>
                                      </div>
                                      <div className="clearfix"></div>
                                      <div className="medium-6 columns">
                                          <div className="form-group">
                                          <label>Name*</label>
                                          <Field
                                              name="name"
                                              validate={[required, maxLength30]}
                                              component={renderTextInputField}
                                              maxLength="30"
                                          />
                                          </div>
                                      </div>
                                      <div className="medium-6 columns">
                                          <div className="form-group">
                                          <label>Email</label>
                                          <Field
                                              name="email"
                                              component={renderEmailInputField}
                                              isDisabled={true}
                                          />
                                          </div>
                                      </div>
                                      <div className="clearfix"></div>
                                      <div className="medium-6 left columns">
                                          <div className="form-group">
                                              <label>Where do you live? (City, State or Province, Country)*</label>
                                               <Field
                                                    name="location"
                                                    validate={[required, maxLength30]}
                                                    maxLength="100"
                                                    component={renderTextInputField}
                                                />
                                          </div>
                                      </div>
                                      <div className="clearfix"></div>
                                      <div className="medium-6 left columns">
                                          <div className="form-group">
                                              <a href="/change-password" className="link">Change Password</a>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>

                </section>
                <section className="profile-questions">
                    <div className="row">
                        <div className="medium-12 columns">
                            <h1 className="text-center">
                                Profile Questions
                            </h1>
                            <p className="text-center m-b30 m-t20">
                                Answering the questions below enables the system to customize your earthDECK. <br /> You can revise later.
                            </p>
                            <div id="yourStory" className="profile-questions-heading primary-gradient-bg">
                                Your story
                            </div>
                            <div className="questions">
                                <div className="form-group">
                                    <Field
                                        label="Do you have a story we should know about?"
                                        name="profile.yourStories.selectedOption"
                                        type="radio"
                                        value="working on championing a stories"
                                        component={renderRadioInputField}
                                        onChange={this.onChangeStoryCheckBox}
                                    />
                                </div>
                                <FieldArray name={`profile.yourStories.nameWebsites`} deleteItem={this.deleteItem} component={renderStoryItems}/>
                            </div>
                            <div className="profile-questions-heading primary-gradient-bg m-t30">
                                Content you like <span className="note">(Click as many as apply)</span>
                            </div>
                            <div className="questions">
                                <Field name={`profile.contentLike`} component={CheckboxGroup} options={this.state.contentLikeList} />
                            </div>
                            <div className="profile-questions-heading primary-gradient-bg m-t30">
                                You & your social network(s) <span className="note">(Click as many as apply)</span>
                            </div>
                            <div className="questions">
                                <Field name={`profile.socialNetworks.selectedOptions`} component={CheckboxGroup} options={this.state.socialNetworkList} />
                                <div className="row m-t20">
                                    <div className="medium-12 columns">
                                        <div className="form-group">

                                            <label>Other comments (not covered above)</label>
                                            <Field
                                                name={`profile.socialNetworks.other`}
                                                validate={[maxLength50]}
                                                component={renderTextInputField}
                                                maxLength="50"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                    <div className="medium-12 columns">
                        <div className="form-group text-center m-t30 m-b30">
                            <button type={'submit'} className="btn-primary primary-gradient-bg">SAVE</button>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </section>
                </form>
                </div>
            );
        } else {
            return <Loader loaderContent='form-submission' />
        }
    }
}

/**
 * Form validation
 * @param values
 * @returns {{}}
 */
function validate(values) {
    let errors = {};

    if(!values.name){
        errors.name = langs.validation_messages.fullname_required;
    }

    if (values.name && values.name.length > 30){
        errors.name = langs.validation_messages.fullname_pattern;
    }

    if(!values.email){
        errors.email = langs.validation_messages.email_required;
    }

    if(values.email && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values.email) == false){
        errors.email = langs.validation_messages.email_pattern;
    }

    if(!values.password){
        errors.password = langs.validation_messages.password_required;
    }

    if(values.password && values.password.length > 32){
        errors.password = langs.validation_messages.password_length;
    }

    return errors;
}

const mapStateToProps = ({ user }) => {
  const { authUserDetails } = user;
  let returnObj = { name: '',
                    email: '',
                    location: '',
                    profile: {nameWebsites : [{Title:'', Website:''}]}};

  //Keep values in initial values object to be passed on form submit
    returnObj.authUserDetails = authUserDetails;
    if(authUserDetails){
        returnObj.initialValues  = {
            name: authUserDetails.name,
            email: authUserDetails.email,
            location: authUserDetails.location,
            profile: authUserDetails.profile,

        };
    }

    return returnObj;
};

export default connect(mapStateToProps, {editProfile, getProfileDetailsLocalStorage, getUserProfileDetails, eventTracking})(reduxForm({
    form: 'EditProfileForm',
    validate,
    enableReinitialize: true,
    onSubmitFail: (errors) => {
        focusOnError(errors);
    }
})(EditProfile));



// WEBPACK FOOTER //
// ./components/User/EditProfile.js